import React from 'react'

import Layout from '../../components/Layout'

const Studies = () => {
  return <Layout>THIS SHIT IS RIGHT HERE YO!</Layout>
}

export default Studies
